module.exports = __webpack_public_path__ + "img/a2@2x.f8744334.png";